window.shareProduct = function() {
    class ShareButton extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                shareButton: this.querySelector('button'),
                successMessage: this.querySelector('[id^="ShareMessage"]'),
                urlInput: this.querySelector('input'),
                content: this.querySelector('.share-button__fallback'),
                copyButton: this.querySelector('.button-copy'),
                closeButton: this.querySelector('.share-button__close')
            }

            // Safety check before attaching event listeners
            if (this.elements.shareButton) {
                this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
            }

            if (this.elements.copyButton) {
                this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
            }

            if (this.elements.closeButton) {
                this.elements.closeButton.addEventListener('click', this.closeDetails.bind(this));
            }

            const overlay = document.querySelector('.background-overlay');
            if (overlay) {
                overlay.addEventListener('click', this.closeDetails.bind(this));
            }

            console.log('[ShareButton] Initialized'); // Confirm script is running
        }

        toggleDetails(event) {
            event.preventDefault();
            event.stopPropagation();

            const url = this.elements.urlInput?.getAttribute('data-url') || window.location.href;

            this.getPosition();

            if (this.elements.successMessage) {
                this.elements.successMessage.classList.add('hidden');
            }

            if (this.elements.urlInput) {
                this.elements.urlInput.setAttribute('value', url);
                this.elements.urlInput.classList.remove('is-copy');
            }

            if (this.elements.content) {
                this.elements.content.classList.toggle('is-open');
            }

            document.body.classList.add('modal-share-open');
        }

        copyToClipboard(event) {
            event.preventDefault();
            event.stopPropagation();

            if (!this.elements.urlInput?.classList.contains('is-copy')) {
                navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
                    this.elements.successMessage?.setAttribute('aria-hidden', false);
                    this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
                    this.elements.urlInput.classList.add('is-copy');

                    setTimeout(() => {
                        this.elements.successMessage?.setAttribute('aria-hidden', true);
                    }, 6000);
                });
            }
        }

        closeDetails(event) {
            event.preventDefault();

            const url = this.elements.urlInput?.getAttribute('data-url') || window.location.href;

            if (this.elements.successMessage) {
                this.elements.successMessage.classList.add('hidden');
            }

            if (this.elements.urlInput) {
                this.elements.urlInput.setAttribute('value', url);
                this.elements.urlInput.classList.remove('is-copy');
            }

            if (this.elements.content) {
                this.elements.content.classList.remove('is-open');
            }

            document.body.classList.remove('modal-share-open');
        }

        getPosition() {
            // Desktop position logic (commented out)
        }

        getProductInfoPosition() {
            const productDetails = document.querySelector('.productView-details');
            return productDetails?.offsetTop;
        }

        setProductInfoTop(top) {
            const productDetails = document.querySelector('.productView-details');
            productDetails?.style.setProperty('--sticky-top', top + 'px');
        }
    }

    if (!customElements.get('share-button')) {
        customElements.define('share-button', ShareButton);
    }
};

var shareShow = document.body.classList.contains('quick-view-show'),
    productShare = document.querySelectorAll('.halo-productView .productView-share').length;

if (document.body.classList.contains('template-product')) {
    if (!shareShow && productShare) {
        window.shareProduct();
    } else if (shareShow && productShare === 0) {
        window.shareProduct();
    }
} else {
    window.shareProduct();
}
